<!-- eslint-disable vue/no-v-html -->
<template>
  <page>
    <page
      :custom-style="{
        paddingBottom: keyInfo.isign_agreement == 0 ? '120px' : '0',
        backgroundColor: '#f5f5f5'
      }"
    >
      <div class="panel">
        <div class="company">
          <h2>商户信息</h2>
          <p>门店ID：{{ keyInfo.company_id }}</p>
          <p>门店名称：{{ keyInfo.company_name }}</p>
          <p>负责人： {{ keyInfo.person_name }}</p>
          <p>
            负责人电话：
            <a @click="makeCall(keyInfo.company_phone)">{{
              keyInfo.company_phone
            }}</a>
          </p>
        </div>
        <div id="keyContent" v-html="keyInfo.agreement_content"></div>
      </div>
    </page>
    <div v-if="keyInfo.isign_agreement == 0" class="bottom-panel">
      <label :class="themeColorClass" @click="toggle">
        <span
          :class="
            selected
              ? 'mcicon-xuankuang-gouxuan'
              : 'mcicon-xuankuang-weixuanzhong'
          "
        ></span
        >我已阅读并同意上述协议
      </label>
      <p>
        此协议需要您当面和{{
          APP_CONFIG.app_short_name
        }}销售或者司机签署，以便进行钥匙交接
      </p>
      <div
        type="button"
        class="btn"
        :class="{ unvalid: selected, ...themeAppColorClass }"
        @click="submit"
      >
        提交
      </div>
    </div>
  </page>
</template>
<script>
import { makeCall } from '@/utils/utils'
import { miniProgramEnv } from '@/defines/environment'
import { APP_CONFIG } from '@/defines/environment/config'
import { API } from '@/api'
import { navBar } from '@/utils/native_interactions/native_bar'
import { DialogAlert } from '@/utils/dialog.js'
import themeMixin from '@/common/mixins/theme'
export default {
  mixins: [themeMixin],
  beforeRouteEnter(to, from, next) {
    next(vm => {
      navBar.setTitle({
        text: '商户钥匙托管电子协议'
      })
    })
  },
  data() {
    return {
      keyInfo: {},
      selected: false,
      isMiniProgram: miniProgramEnv.isMiniProgram,
      showTitile: !window.appMethod, // 只有微信显示
      APP_CONFIG
    }
  },
  computed: {
    styleInit: function () {
      return {
        top: !this.showTitile ? '0' : '',
        bottom: this.keyInfo.isign_agreement === 0 ? '122px' : '20px'
      }
    },
    styleObj: function () {
      return {
        top: !window.appMethod ? '42px' : '0',
        paddingBottom: this.keyInfo.isign_agreement === 0 ? '140px' : '20px'
      }
    }
  },
  created() {
    this.getKeyContent()
  },
  methods: {
    makeCall,
    /**
     * [获取协议所有内容]
     */
    async getKeyContent() {
      this.$Loading()
      try {
        const res = await API.userCenter.getKeyContent()
        this.keyInfo = res
      } catch (error) {
        this.$catch(error)
      }
      this.$Loading.hide()
    },
    async submitKey(data) {
      this.$Loading()
      try {
        await API.userCenter.submitKey(data)
        this.getKeyContent()
        DialogAlert('协议签署成功')
      } catch (error) {
        DialogAlert('协议签署失败')
      }
      this.$Loading.hide()
    },
    toggle() {
      this.selected = !this.selected
    },
    submit() {
      if (this.keyInfo.isign_agreement === 0 && this.selected) {
        this.submitKey({
          sign_agreement_version: this.keyInfo.sign_agreement_version
        })
      } else {
        DialogAlert('请先同意协议内容，再提交！')
      }
    },
    goBack() {
      this.$back()
    }
  }
}
</script>
<style lang="scss" scoped>
.bottom-panel {
  position: fixed;
  bottom: 0;
  left: 0;

  width: 100%;

  padding: 14px 12px;

  background: #ffffff;
  label {
    line-height: 16px;
    color: #0daf52;
    span {
      margin-right: 8px;
    }
  }
  p {
    margin: 8px 0 12px;

    font-size: 12px;
    line-height: 14px;
    color: #ff4e4e;
  }
  .btn {
    display: block;

    background: #9f9f9f;

    border-radius: 4px;

    font-size: 16px;
    line-height: 44px;
    text-align: center;
    color: #ffffff;
    &.unvalid {
      background: #0daf52;
    }
    &.small {
      &.unvalid {
        background: $theme-main_small;
      }
    }
  }
}
.panel {
  padding: 15px 15px 10px;
  .company {
    margin-bottom: 20px;
    h2 {
      margin: 5px 0;

      font-size: 16px;
      color: #333333;
    }
    p {
      margin: 5px 0;

      line-height: 22px;
      color: #666666;
      a {
        color: #4990e2;
      }
    }
  }
}
#keyContent {
  ::v-deep h2 {
    margin: 20px 0 5px;

    font-size: 18px;
    color: #333333;
  }
  ::v-deep p {
    margin: 5px 0;

    font-size: 14px;
    line-height: 22px;
    color: #333333;
    a {
      color: #4990e2;
    }
  }
}
</style>
